import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _toArray from '@babel/runtime/helpers/esm/toArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DayPickerRangeController as DayPickerRangeController$1 } from 'react-dates';
import { DatePickerNavigation, DatePickerDay, renderMonthElement } from '@elliemae/ds-date-picker';
import ChevronLeft from '@elliemae/ds-icons/ChevronLeft';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';

var _convertPropToCssClas = convertPropToCssClassName('datepicker-range'),
    classNameElement = _convertPropToCssClas.classNameElement,
    classNameBlock = _convertPropToCssClas.classNameBlock;

var DayPickerRangeController = function DayPickerRangeController(_ref) {
  var _ref$endDate = _ref.endDate,
      endDate = _ref$endDate === void 0 ? undefined : _ref$endDate,
      _ref$startDate = _ref.startDate,
      startDate = _ref$startDate === void 0 ? undefined : _ref$startDate,
      _ref$displayFormatDay = _ref.displayFormatDay,
      displayFormatDay = _ref$displayFormatDay === void 0 ? 'D' : _ref$displayFormatDay,
      _ref$focusedInput = _ref.focusedInput,
      focusedInput = _ref$focusedInput === void 0 ? undefined : _ref$focusedInput,
      _ref$enableOutsideDay = _ref.enableOutsideDays,
      enableOutsideDays = _ref$enableOutsideDay === void 0 ? false : _ref$enableOutsideDay,
      _ref$onDatesChange = _ref.onDatesChange,
      onDatesChange = _ref$onDatesChange === void 0 ? function () {
    return null;
  } : _ref$onDatesChange,
      _ref$onFocusChange = _ref.onFocusChange,
      onFocusChange = _ref$onFocusChange === void 0 ? function () {
    return null;
  } : _ref$onFocusChange,
      _ref$onOutsideClick = _ref.onOutsideClick,
      onOutsideClick = _ref$onOutsideClick === void 0 ? function () {
    return null;
  } : _ref$onOutsideClick,
      _ref$isDayBlocked = _ref.isDayBlocked,
      isDayBlocked = _ref$isDayBlocked === void 0 ? function () {
    return null;
  } : _ref$isDayBlocked,
      _ref$isDayHighlighted = _ref.isDayHighlighted,
      isDayHighlighted = _ref$isDayHighlighted === void 0 ? function () {
    return null;
  } : _ref$isDayHighlighted,
      _ref$isOutsideRange = _ref.isOutsideRange,
      isOutsideRange = _ref$isOutsideRange === void 0 ? function () {
    return null;
  } : _ref$isOutsideRange,
      _ref$onNextMonthClick = _ref.onNextMonthClick,
      onNextMonthClick = _ref$onNextMonthClick === void 0 ? function () {
    return null;
  } : _ref$onNextMonthClick,
      _ref$onPrevMonthClick = _ref.onPrevMonthClick,
      onPrevMonthClick = _ref$onPrevMonthClick === void 0 ? function () {
    return null;
  } : _ref$onPrevMonthClick,
      otherProps = _objectWithoutProperties(_ref, ["endDate", "startDate", "displayFormatDay", "focusedInput", "enableOutsideDays", "onDatesChange", "onFocusChange", "onOutsideClick", "isDayBlocked", "isDayHighlighted", "isOutsideRange", "onNextMonthClick", "onPrevMonthClick"]);

  var datePickerRef = useRef();
  useEffect(function () {
    var handleMouseUp = function handleMouseUp() {
      var focusedElement = document.activeElement;
      focusedElement.blur();
    };

    var handleKeyDown = function handleKeyDown(event) {
      var _document$getElements = document.getElementsByClassName('CalendarMonthGrid_month__horizontal')[1].getElementsByClassName('CalendarDay'),
          _document$getElements2 = _toArray(_document$getElements),
          firstDay = _document$getElements2[0],
          restOfDays = _document$getElements2.slice(1);

      var _restOfDays$slice = restOfDays.slice(-1),
          _restOfDays$slice2 = _slicedToArray(_restOfDays$slice, 1),
          lastDay = _restOfDays$slice2[0];

      var focusedElement = document.activeElement;

      var _document$getElements3 = document.getElementsByClassName('DayPickerNavigation_button'),
          _document$getElements4 = _slicedToArray(_document$getElements3, 2),
          prev = _document$getElements4[0],
          next = _document$getElements4[1];

      switch (event.key) {
        case 'Home':
          event.stopPropagation();
          firstDay.focus();
          break;

        case 'End':
          event.stopPropagation();
          lastDay.focus();
          break;

        case 'Enter':
        case ' ':
          if (focusedElement === prev) {
            event.stopPropagation();
            setTimeout(function () {
              prev.focus();
            }, 240);
          } else if (focusedElement === next) {
            event.stopPropagation();
            setTimeout(function () {
              next === null || next === void 0 ? void 0 : next.focus();
            }, 240);
          }

          break;

        case 'Tab':
          if (firstDay === focusedElement || restOfDays.includes(focusedElement)) {
            event.preventDefault();
            prev.focus();
          }

          break;
      }
    };

    datePickerRef.current.addEventListener('mouseup', handleMouseUp, false);
    datePickerRef.current.addEventListener('keydown', handleKeyDown, false);
    return function () {
      if (datePickerRef.current) {
        datePickerRef.current.removeEventListener('mouseup', handleMouseUp, false);
        datePickerRef.current.removeEventListener('keydown', handleKeyDown, false);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: datePickerRef,
    className: classNameBlock('wrapper-day-picker-single-date-controller'),
    "data-testid": otherProps['data-testid'] || 'date-range-picker-controller'
  }, /*#__PURE__*/React.createElement(DayPickerRangeController$1, _extends({}, otherProps, {
    isDayBlocked: isDayBlocked,
    isDayHighlighted: isDayHighlighted,
    isOutsideRange: isOutsideRange,
    enableOutsideDays: enableOutsideDays,
    endDate: endDate,
    focused: true,
    focusedInput: focusedInput,
    hideKeyboardShortcutsPanel: true,
    navNext: /*#__PURE__*/React.createElement(DatePickerNavigation, {
      className: classNameElement('navigation-next')
    }),
    navPrev: /*#__PURE__*/React.createElement(DatePickerNavigation, {
      className: classNameElement('navigation-prev'),
      icon: ChevronLeft
    }),
    onDatesChange: onDatesChange,
    onFocusChange: onFocusChange,
    onOutsideClick: onOutsideClick,
    onNextMonthClick: onNextMonthClick,
    onPrevMonthClick: onPrevMonthClick,
    renderDayContents: function renderDayContents(date) {
      return /*#__PURE__*/React.createElement(DatePickerDay, {
        className: classNameElement('day-contents'),
        date: date.format(displayFormatDay)
      });
    },
    renderMonthElement: renderMonthElement,
    startDate: startDate
  })));
};

DayPickerRangeController.propTypes = {
  endDate: PropTypes.instanceOf(Date, moment),
  startDate: PropTypes.instanceOf(Date, moment),
  displayFormatDay: PropTypes.string,
  focusedInput: PropTypes.bool,
  onDatesChange: PropTypes.func,
  onFocusChange: PropTypes.func,
  onOutsideClick: PropTypes.func,
  onNextMonthClick: PropTypes.func,
  onPrevMonthClick: PropTypes.func,
  enableOutsideDays: PropTypes.bool,
  isDayBlocked: PropTypes.func,
  isDayHighlighted: PropTypes.func,
  isOutsideRange: PropTypes.func
};

export default DayPickerRangeController;
//# sourceMappingURL=DayPickerRangeController.js.map
